import { Injectable, inject } from '@angular/core';
import { RecentlyViewedService } from '@df/catalog-ui/recently-viewed/recently-viewed.service';
import { IRelatedProductsCallback, RelatedProductsService } from '@df/catalog-ui/related-products/related-products.service';
import difference from 'lodash-es/difference';

@Injectable({
    providedIn: 'root'
})
export class RecentlyViewedEngine {
    /**
     * Recently viewed items service
     */
    private recentService = inject(RecentlyViewedService);

    /**
     * models getter
     */
    get(sourceIds: number[], cb: IRelatedProductsCallback) {
        cb(difference(this.recentService.collection, sourceIds || []));
    }

    /**
     * Non cachable - results change all the time
     */
    noCache = true;
}

RelatedProductsService.registerEngine('recent', RecentlyViewedEngine);
